import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
`;

const baseInputStyles = css`
  align-self: flex-start;
  width: 100%;
  background-color: ${(props) => props.theme['modal.input.bg.color']};
  margin-bottom: 40px;

  color: ${(props) => props.theme['modal.input.color']};
  font-family: inherit;
  line-height: 42px;
  font-size: ${(props) => props.fontSize}px;

  outline: none;
  transition: all 0.3s ease;
  border: 1px solid ${(props) => props.theme['modal.input.border.color']};
  border-style: none none solid none;

  &:focus {
    border: 1px solid ${(props) => props.theme['color.primary']};
    border-style: none none solid none;
    background: none;
  }

  ::placeholder {
    color: ${(props) => props.theme['modal.input.placeholder.color']};
    font-size: ${(props) => props.fontSize}px;
  }
`;

export const PluginInput = styled.input`
  height: ${(props) => props.height || 45}px;

  ${baseInputStyles}
`;

export const PluginTextareaWrapper = styled.div`
  width: 100%;

  textarea {
    ${baseInputStyles}
  }
`;

export const TextWrapDescription = styled.div`
  align-self: flex-start;
  margin-top: 15px;
  line-height: 22px;
  font-size: 16px;
  color: ${(props) => props.theme['modal.description.color']};
`;

export const TextWrapSubheader = styled.div`
  font-weight: 600;
  line-height: 30px;
  font-size: 22px;
  margin-bottom: 55px;
  color: ${(props) => props.theme['modal.title.color']};
`;

export const TextWrapSubheaderTwo = styled.div`
  align-self: flex-start;
  font-weight: 600;
  font-size: 20px;
  height: 27px;
  margin-bottom: 5px;
  color: ${(props) => props.theme['modal.title.color']};
`;
